import { render, staticRenderFns } from "./RemindPassword.vue?vue&type=template&id=2e73f0c7&scoped=true&"
import script from "./RemindPassword.vue?vue&type=script&lang=js&"
export * from "./RemindPassword.vue?vue&type=script&lang=js&"
import style0 from "./RemindPassword.vue?vue&type=style&index=0&id=2e73f0c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e73f0c7",
  null
  
)

export default component.exports